module.exports = __webpack_public_path__ + "img/red_coupon.90669e12.png";